import React from 'react';

export default function ProgressBar({ currentStage, totalStages, percentage }) {
  return (
    <div className="w-full bg-gray-200 rounded-full h-3 mb-6">
      <div
        className="bg-gradient-to-r from-blue-500 to-blue-600 h-3 rounded-full transition-all duration-500 ease-out"
        style={{ width: `${percentage}%` }}
      />
      <div className="mt-2 text-sm text-gray-600 text-center">
        Stage {currentStage} of {totalStages}
      </div>
    </div>
  );
}
